<template>
  <div id="contenedor-configuracion-plantillas-listado-desktop">
    <v-data-table
      :headers="headers"
      :items="listadoPlantillas">
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      <template v-if="!soloLectura" v-slot:[`item.acciones`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="removerPlantilla(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
          </template>
          <span>Borrar</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs"
              v-if="item.path !== ''"
              v-on="on"
              @click="descargarPlantilla(item)"
              :loading="mostrarDescargando===item.id">
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
          </template>
          <span>Descargar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';
import mixConfiguracionPlantillas from '@/components/administracion/configuracion/plantillas/mixConfiguracionPlantillas';

export default {
  name: 'ConfiguracionPlantillasListadoDesktop',
  props: {
    modulo: {
      type: String,
      required: true,
    },
    listadoPlantillas: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    FechaHumano,
  },
  mixins: [mixConfiguracionPlantillas],
  data() {
    return {
      headers: [
        {
          text: 'Nombre/Platilla',
          align: 'start',
          sortable: true,
          value: 'nombre',
        },
        { text: 'Fecha', value: 'createdAt', sortable: true },
        { text: '', value: 'acciones', sortable: false },
      ],
      mostrarDescargando: null,
    };
  },
  methods: {
    removerPlantilla(plantilla) {
      eventBus.$emit('eliminar-plantilla', plantilla);
    },
  },
};
</script>

<style lang="scss">

</style>
